import React from 'react';
import { MapPinIcon } from 'lucide-react';
export function ServiceAreas() {
  return <section className="w-full py-20 px-4 relative overflow-hidden" style={{
    backgroundColor: '#1B2A4A'
  }} id="service-areas" aria-label="Service areas" data-id="element-105">
      {/* Subtle dotted pattern overlay */}
      <div className="absolute inset-0 pointer-events-none opacity-10" style={{
      backgroundImage: 'radial-gradient(circle, rgba(255,255,255,0.6) 1px, transparent 1px)',
      backgroundSize: '28px 28px'
    }} aria-hidden="true" data-id="element-106" />

      <div className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-107">
        {/* Heading */}
        <h2 className="font-bold text-4xl text-white" data-id="element-108">
          Serving Clients Nationwide
        </h2>
        <p className="text-gray-300 text-base mt-3 mb-12" data-id="element-109">
          PRECISE TRANSCRIPTS LLC offers transcription and translation services
          across New York, New Jersey, Connecticut, Los Angeles (California),
          and Chicago (Illinois).
        </p>

        {/* Location Badges */}
        <div className="flex flex-wrap justify-center gap-6 mb-14" data-id="element-110">
          <div className="flex items-center gap-2" data-id="element-111">
            <MapPinIcon className="w-5 h-5 flex-shrink-0" style={{
            color: '#C8962E'
          }} aria-hidden="true" data-id="element-112" />
            <span className="text-white font-medium border-b-2 pb-0.5" style={{
            borderColor: '#C8962E'
          }} data-id="element-113">
              New York
            </span>
          </div>
          <div className="flex items-center gap-2" data-id="element-114">
            <MapPinIcon className="w-5 h-5 flex-shrink-0" style={{
            color: '#C8962E'
          }} aria-hidden="true" data-id="element-115" />
            <span className="text-white font-medium border-b-2 pb-0.5" style={{
            borderColor: '#C8962E'
          }} data-id="element-116">
              New Jersey
            </span>
          </div>
          <div className="flex items-center gap-2" data-id="element-117">
            <MapPinIcon className="w-5 h-5 flex-shrink-0" style={{
            color: '#C8962E'
          }} aria-hidden="true" data-id="element-118" />
            <span className="text-white font-medium border-b-2 pb-0.5" style={{
            borderColor: '#C8962E'
          }} data-id="element-119">
              Connecticut
            </span>
          </div>
          <div className="flex items-center gap-2" data-id="element-120">
            <MapPinIcon className="w-5 h-5 flex-shrink-0" style={{
            color: '#C8962E'
          }} aria-hidden="true" data-id="element-121" />
            <span className="text-white font-medium border-b-2 pb-0.5" style={{
            borderColor: '#C8962E'
          }} data-id="element-122">
              Los Angeles, CA
            </span>
          </div>
          <div className="flex items-center gap-2" data-id="element-123">
            <MapPinIcon className="w-5 h-5 flex-shrink-0" style={{
            color: '#C8962E'
          }} aria-hidden="true" data-id="element-124" />
            <span className="text-white font-medium border-b-2 pb-0.5" style={{
            borderColor: '#C8962E'
          }} data-id="element-125">
              Chicago, IL
            </span>
          </div>
        </div>

        {/* CTA */}
        <a href="#" className="inline-flex items-center justify-center font-bold rounded-lg px-10 py-4 text-lg min-h-[52px] transition-opacity hover:opacity-90" style={{
        backgroundColor: '#C8962E',
        color: '#1B2A4A'
      }} data-id="element-126">
          Get Your Free Quote Today
        </a>
      </div>
    </section>;
}